<ds-modal [modal]="modal" [title]="'risk_management_status' | translate">
  <div data-test-id="available-levels">
    <h3 class="ds-visually-hidden">{{ 'available_levels' | translate }}</h3>
    <ol class="available-levels">
      @for (levelText of availableLevels; track $index; let i = $index) {
        <li class="text-nowrap me-2">
          @if (i > 0) {
            <ds-icon [icon]="Icons.ChevronRight" class="me-2"></ds-icon>
          }
          {{ levelText }}
        </li>
      }
    </ol>
  </div>
  <div>
    <h3 class="my-4" data-test-id="risk-score-level">{{ currentLevelText }}</h3>
    <p data-test-id="level-explanation">
      {{ levelExplanation }}
    </p>
    @if (additionalExplanation) {
      <p data-test-id="additional-explanation">
        {{ additionalExplanation | translate }}
      </p>
    }
  </div>
  @if (findingsData) {
    <div data-test-id="findings-breakdown">
      <span>{{ 'findings_breakdown_label' | translate: [formattedComputedDate] }}</span>
      <ul class="mt-2">
        @for (value of findingsBreakdown; track $index; let i = $index) {
          <li>
            {{ value }}
          </li>
        }
      </ul>
    </div>
  }
</ds-modal>
